import baseProperty from './_baseProperty.js';

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

export default asciiSize;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/_asciiSize.js
// module id = 3372
// module chunks = 0